import queryString from 'query-string';

export default function generatePaginationUrl(
  pageParam: number,
  requestUrl = '',
  paramName = 'page'
) {
  const { url, query } = queryString.parseUrl(
    typeof window === 'undefined' ? requestUrl : window.location.href
  );

  const qs = queryString.stringify({
    ...query,
    [paramName]: pageParam > 1 ? pageParam : undefined,
  });

  if (!qs) {
    return url;
  }

  return `${url}?${qs}`;
}
